<script>
import StoreCard from '@maison/components/store/StoreCard';
import Store from '@phoenix/components/Store';
import userPositionMixin from '@phoenix/mixins/userPositionMixin';
import { PhxIcon } from '@phx-styleguides/als';

export default {
  components: {
    StoreCard,
    PhxIcon,
  },

  mixins: [userPositionMixin],

  props: {
    stores: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    enableNearMe: {
      type: Boolean,
      required: false,
      default: true,
    },
    boutiquesPageUrl: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    hasTitle() {
      return this.title && this.title.length > 0;
    },

    hasSubtitle() {
      return this.subtitle && this.subtitle.length > 0;
    },

    maxItems() {
      return this.stores ? this.stores.length : 0;
    },
  },
};
</script>

<template>
  <div class="boutique-push">
    <div class="boutique-push__header">
      <div v-if="hasTitle || hasSubtitle" class="headings boutique-push__headings">
        <h2 v-if="hasTitle" class="h3">{{ title }}</h2>
        <h3 v-if="hasSubtitle" class="headings__subtitle h6">{{ subtitle }}</h3>
      </div>
      <button
        v-if="enableNearMe"
        ref="positionBtn"
        class="btn btn--secondary btn--icon boutique-push__btn-geolocalization"
        @click.prevent="useMyPosition"
      >
        <span class="btn__icon">
          <phx-icon icon="geoloc" />
        </span>
        <span class="btn__text">{{ $t('Store.discover.nearest') }}</span>
      </button>
    </div>
    <div class="grid gap-lg grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
      <store-card
        v-for="(store, index) in hasStoresNearMe ? nearStores : stores"
        :key="store.id ?? index"
        v-bind="store"
        :should-display-address="false"
      />
    </div>
    <div v-if="enableNearMe" class="grid grid-cols-1">
      <a :href="boutiquesPageUrl" class="btn mt-base lg:mt-md mx-auto">
        <span class="btn__text">{{ $t('Store.find.another') }}</span>
      </a>
    </div>
  </div>
</template>
